import { createAction, props } from '@ngrx/store';
import { IDebtsState } from './debts.state';

export const initDebtsAction = createAction('[debts Page] debts page');

export const setDebtsAction = createAction(
  '[debts Page] set data',
  props<IDebtsState>()
);
